export default "__VITE_ASSET__BWiNGDAl__"